export default __webpack_public_path__ + "static/media/map_explore.4c90dfa8.png";